<template>
    <div id="confi-muster-modal-wrapper">
        <div class="modal fade muster__modal" id="confi-muster" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>{{ $translate("Weberbuero::Template.singleMusterModalHeadline") }}</h3>
                        <svg data-dismiss="modal" height="26" width="27" @click="detachModal()">
                            <use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                    </div>
                    <div class="modal-body">
                        <div class="muster__variation" id="muster-selected-article" :muster-selection="modalActiveArticle">
                            <ul class="configurator-variants__list configurator-variants__list--modal">
                                <li v-for="product in productList" class="configurator-variants__item" :class="{'configurator-variants__item--active': modalSelectedMuster === product.id }" @click="$emit('switchMuster', product.id)">
                                    <div class="configurator-variants__img-wrap">
                                        <div class="configurator-variants__img-container">
                                            <div
                                                    class="configurator-variants__img"
                                                    :style="{ backgroundImage: 'url(https://bilder.weberbuero.de/frontend/images/materials/thumbs/'  + product.img + '.jpg)' }"/>
                                        </div>
                                    </div>
                                    <div class="configurator-variants__title">
                                        <p>{{ product.name }}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 muster__modal--pr-7">
                                <div class="input-unit">
                                    <select name="salutation" class="form-control">
                                        <option value="">{{ $translate("Weberbuero::Template.singleItemPleaseSelect") }}</option>
                                        <option :value="addressSalutationMale">{{ addressSalutationMale }}</option>
                                        <option :value="addressSalutationFemale">{{ addressSalutationFemale }}</option>
                                        <option :value="addressSalutationDiverse">{{ addressSalutationDiverse }}</option>
                                        <option :value="addressSalutationCompany">{{ addressSalutationCompany }}</option>
                                    </select>
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalAnrede") }}*</label>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 muster__modal--pl-7">
                                <div class="input-unit">
                                    <input required type="email" name="email">
                                    <label>E-Mail*</label>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 muster__modal--pr-7">
                                <div class="input-unit">
                                    <input required type="text" name="name">
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalVorname") }}*</label>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 muster__modal--pr-7 muster__modal--pl-7">
                                <div class="input-unit">
                                    <input required type="text" name="lastname">
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalNachname") }}*</label>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 muster__modal--pl-7">
                                <div class="input-unit">
                                    <input type="text" name="company">
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalCompany") }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-md-3">
                            <div class="col-12 col-md-8 muster__modal--pr-7">
                                <div class="input-unit">
                                    <input required type="text" name="street">
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalStrasse") }}*</label>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 muster__modal--pl-7">
                                <div class="input-unit">
                                    <input required type="text" name="number">
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalNr") }}*</label>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 muster__modal--pr-7">
                                <div class="input-unit">
                                    <input required type="number" name="plz">
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalPLZ") }}*</label>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 muster__modal--pr-7 muster__modal--pl-7">
                                <div class="input-unit">
                                    <input required type="text" name="place">
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalOrt") }}*</label>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 muster__modal--pl-7">
                                <div class="input-unit">
                                    <input required type="text" name="country">
                                    <label>{{ $translate("Weberbuero::Template.singleMusterModalLand") }}*</label>
                                </div>
                            </div>
                        </div>

                        <accept-privacy-policy-check
                                class="mt-3 mb-0"
                                v-model="privacyPolicyAccepted">
                        </accept-privacy-policy-check>

                        <!--<div class="row mt-md-3">
                            <div class="col-12">
                                <div class="form-check gtc-form">
                                    <input type="checkbox" value="" class="form-check-input gtc-checkbox" id="gtc-accept-muster-confi">
                                    <span class="checkmark"></span>
                                    {% autoescape %}
                                    <label for="gtc-accept-muster-confi" class="form-check-label gtc-label">
                                        {% set policyContent %}&lt;!&ndash;
                                                &ndash;&gt;<a href="{{ urls.privacyPolicy }}" target="_blank" class="text-appearance">
                                        <span>{{ trans("Ceres::Template.checkoutPrivacyPolicy", {"hyphen": "&shy;"}) }}</span>
                                    </a>&lt;!&ndash;
                                            &ndash;&gt;{% endset %}

                                        {{ trans("Weberbuero::Template.singleMusterModalPrivacyPolicy", {"policy": policyContent}) }}<sup>*</sup></label>
                                    {% endautoescape %}
                                </div>
                            </div>
                        </div>-->

                        <div class="row mt-md-3">
                            <div class="col-12 col-md-4 offset-md-4">
                                <button class="btn muster__modal-send muster__modal-send--vue"
                                        :disabled="!privacyPolicyAccepted" @click.prevent="send()"
                                        id="muster__send">{{ $translate("Weberbuero::Template.singleMusterModalButtonText") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TranslationService from "ceres/app/services/TranslationService";
    import AcceptPrivacyPolicyCheck from "../../customer/AcceptPrivacyPolicyCheck.vue"
    export default {
        name: "MusterModal",
        props: {
            modalActiveArticle:{},
            modalSelectedMuster:{},
            productList: Array
        },
        components: {
            AcceptPrivacyPolicyCheck
        },
        data(){
            return{
                // generate Translitons on component creation
                addressSalutationMale: TranslationService.translate("Ceres::Template.addressSalutationMale"),
                addressSalutationFemale: TranslationService.translate("Ceres::Template.addressSalutationFemale"),
                addressSalutationDiverse: TranslationService.translate("Ceres::Template.addressSalutationDiverse"),
                addressSalutationCompany: TranslationService.translate("Ceres::Template.addressSalutationCompany"),
                // check if gtc is accepted
                privacyPolicyAccepted: false
            }

        },

        methods:{
            detachModal(){
                $("#confi-muster-modal-wrapper").detach().appendTo('.configurator');
            },

            send(){
                let sel;

                if($(".muster__modal-send--vue").closest('#confi-muster').length){
                    sel = '#confi-muster';
                }else{
                    sel = '#muster';
                }

                $(".has-error").removeClass("has-error");

                var isAllFilled = true;

                $.each($(sel+" .input-unit [required]"), function (index, item) {
                    if ($(item).val() == "") {
                        $(item).addClass("has-error");
                        isAllFilled = false;
                    }
                });

                var $gtc = $('#gtc-accept-muster-confi').length ? $('#gtc-accept-muster-confi') : $(sel+" .gtc-checkbox");

                if($gtc.prop('checked') === false){
                    isAllFilled = false;
                }

                if (isAllFilled) {

                    const mailObj =
                        {
                            salutation: $(sel+" [name=\"salutation\"]").val(),
                            email: $(sel+" [name=\"email\"]").val(),
                            name: $(sel+" [name=\"name\"]").val(),
                            lastname: $(sel+" [name=\"lastname\"]").val(),
                            company: $(sel+" [name=\"company\"]").val(),
                            street: $(sel+" [name=\"street\"]").val(),
                            number: $(sel+" [name=\"number\"]").val(),
                            plz: $(sel+" [name=\"plz\"]").val(),
                            place: $(sel+" [name=\"place\"]").val(),
                            country: $(sel+" [name=\"country\"]").val(),
                            article: $('.configurator').length > 0 ? $("#muster-selected-article").attr("muster-selection") : $('.muster__modal input[name="article"]').val(),
                            articlename: $('.configurator').length > 0 ? $("#muster-selected-article").attr("muster-selection") : $('.muster__modal input[name="articlename"]').val(),
                            message: "xx",
                            userMail: "xx",
                            subject: "xx",
                            type: "muster"
                        };

                    $.ajax({
                        url: "https://www.weberbuero.de/rest/weberbuero/customer/contact/mail",
                        type: "POST",
                        async: true,
                        data: {
                            contactData: mailObj,
                            template: "Weberbuero::Customer.Components.Contact.MusterMail",
                            type: "muster"
                        },
                        success: function (data, textStatus, jqXHR) {
                            // success
                            $(sel).modal("hide");

                            NotificationService.success(
                                TranslationService.translate("Weberbuero::Template.musterSendSuccess")
                            ).closeAfter(10000);
                        },
                        error: function (data) {
                        }
                    });

                }
            }
        },

        mounted()
        {
            this.$nextTick(() => {

            });

        }

    }
</script>

